
import BannerHeader from "./bannerHeader";
import { BannerData } from "types/models/master/MasterApp";
import BannerCreate from "./bannerCreate";
import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";


const defaultBanner: BannerData = {
  id: 0,
  title: "",
  bannerType: "",
  uri: "",
  index: "",
  active: false,
  image: "",
  position:""
};
const BannerIndex: React.FC = () => {
 

 
  return (
    <>
    <AppAnimate animation="transition.slideUpIn" delay={200}>
      <AppCard>
       
          <BannerHeader banner={ defaultBanner} />
            <AppGridContainer>
            <BannerCreate Banner={ defaultBanner} />
            </AppGridContainer>
        
      </AppCard>
    </AppAnimate>
    <AppInfoView />
  </>
  );
};

export default BannerIndex;
